import { injectGlobal } from 'styled-components';
import theme from './theme';

injectGlobal`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-stroke: 0;
  }

  body {
    font-family: 'Helvetica Neue LT Std Light';
  }

  a,
  button {
    outline: none;
    border: none;
    background: transparent;
    text-decoration: none;
    color: ${theme.colorPrimary};
  }

  main {
    position: absolute;
    top: ${theme.headerHeight};
    left: 0;
    width: 100%;
    height: calc(100% - ${theme.headerHeight});
    @media (max-width: ${theme.headerMobileWidth}) {
      top: ${theme.headerMobileHeight};
      height: calc(100% - ${theme.headerMobileHeight});
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fontHeader};
    font-weight: normal;
  }

  input, select {
    appearance: none;
    outline: none;
    border: none;
    border-radius: 0;
    background: transparent;
    padding: 10px;
    font-family: ${theme.font};
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
  }

  label {
    display: block;
    font-family: ${theme.font};
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: left;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  @font-face {
    font-family: 'Garamond Premiere Pro';
    src: url('/assets/fonts/GaramondPremrPro.woff2') format('woff2'),
      url('/assets/fonts/GaramondPremrPro.woff') format('woff');
  }
  @font-face {
    font-family: 'Garamond Premier Pro It';
    src: url('/assets/fonts/GaramondPremrPro-It.woff2') format('woff2'),
      url('/assets/fonts/GaramondPremrPro-It.woff') format('woff');
  }

  @font-face {
    font-family: 'Helvetica Neue LT Std';
    src: url('/assets/fonts/HelveticaNeueLTStd-Md.woff2') format('woff2'),
      url('/assets/fonts/HelveticaNeueLTStd-Md.woff') format('woff');
  }

  @font-face {
    font-family: 'Helvetica Neue LT Std Cn';
    src: url('/assets/fonts/HelveticaNeueLTStd-Cn.woff2') format('woff2'),
      url('/assets/fonts/HelveticaNeueLTStd-Cn.woff') format('woff');
  }
  
  @font-face {
    font-family: 'Helvetica Neue LT Std Bold';
    src: url('/assets/fonts/HelveticaNeueLTStd-Bd.woff2') format('woff2'),
      url('/assets/fonts/HelveticaNeueLTStd-Bd.woff') format('woff');
  }

  @font-face {
    font-family: 'Helvetica Neue LT Std Light';
    src: url('/assets/fonts/HelveticaNeueLTStd-Lt.woff2') format('woff2'),
      url('/assets/fonts/HelveticaNeueLTStd-Lt.woff') format('woff');
  }

  @font-face {
    font-family: 'Helvetica Neue LT Std Med';
    src: url('/assets/fonts/HelveticaNeueLTStd-Md.woff2') format('woff2'),
      url('/assets/fonts/HelveticaNeueLTStd-Md.woff') format('woff');
  }

  @font-face {
    font-family: 'Helvetica Neue LT Std Med Cn';
    src: url('/assets/fonts/HelveticaNeueLTStd-MdCn.woff2') format('woff2'),
      url('/assets/fonts/HelveticaNeueLTStd-MdCn.woff') format('woff');
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js